import React from 'react';

export const GUIDE_UPDATED_LABEL = '15 août 2026';
export const GUIDE_UPDATED_ISO = '2026-08-15';

const ANSWERS = {
    'analyse-cv-ia':
        'Une analyse de CV par IA lit le fichier, évalue la structure, les mots-clés et la clarté, puis sort un score et des pistes concrètes. Ça ne remplace pas un recruteur : ça sert à corriger le CV avant de postuler.',
    'optimiser-cv-ats':
        'Un ATS lit le texte du CV, pas le design. Pour passer le filtre : titres de sections classiques, mots-clés de l’offre, un PDF ou Word simple, sans colonnes ni images.',
    'rediger-cv-percutant':
        'Un CV percutant décrit des résultats, pas seulement des tâches. Une phrase chiffrée vaut mieux qu’une liste de missions. Adaptez le vocabulaire au secteur visé.',
    'cv-reconversion-professionnelle':
        'En reconversion, on met en avant les compétences transférables et les preuves (projets, formations), pas seulement le dernier intitulé de poste.',
    'lettre-motivation':
        'La lettre complète le CV : elle relie votre parcours à une offre précise. Trois courts paragraphes suffisent. Évitez le copier-coller générique.',
    'cv-etudiant':
        'Sans longue expérience, on valorise stages, projets, associations et compétences. Une page suffit souvent. Les résultats concrets comptent plus que la liste des cours.',
    'score-cv':
        'Le score CV mesure surtout la structure, le contenu, les mots-clés et la clarté. On l’améliore en corrigeant d’abord les points les plus faibles, puis en relançant une analyse.',
    'format-cv':
        'Le format chronologique convient à un parcours linéaire. Le format fonctionnel aide en reconversion ou avec des trous. Le mixte convient à la plupart des profils.',
    'erreurs-cv':
        'Les erreurs qui font écarter un CV : fautes, fichier illisible, missions sans résultat, photo inutile, longueur mal calibrée. Corrigez d’abord ce qui empêche la lecture.',
    'photo-cv':
        'En France, la photo n’est pas obligatoire sur un CV. On la met seulement si elle est professionnelle et utile pour le secteur. Un recruteur n’a pas le droit d’écarter une candidature uniquement parce qu’il n’y a pas de photo.',
    'longueur-cv':
        'Une page convient souvent à un profil junior ou à un CV très ciblé. Deux pages si l’expérience le justifie. Au-delà, on coupe plutôt que d’allonger.',
    'mots-cles-cv':
        'Les mots-clés utiles viennent de l’offre et du secteur. On les intègre dans les expériences, pas dans une liste artificielle. Un ATS cherche ces termes dans le texte.',
    'cv-tech':
        'Un CV tech liste la stack réellement utilisée, des liens (GitHub, projets) et des résultats. Les buzzwords sans preuve n’aident ni le recruteur ni l’ATS.',
};

const GuideLead = ({ slug, answer, updatedLabel = GUIDE_UPDATED_LABEL }) => {
    const text = answer || ANSWERS[slug];
    if (!text) return null;

    return (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 mt-6 mb-2 relative z-20">
            <div className="card-surface p-5 sm:p-6">
                <p className="text-slate-800 leading-relaxed">{text}</p>
                <p className="text-xs text-slate-500 mt-3">Mis à jour le {updatedLabel}</p>
            </div>
        </div>
    );
};

export default GuideLead;
